import { PAYMENT_GATEWAYS_CONFIG_URL } from "../config/api";
import { apiClient } from "../utils/apiClient";

export type GatewayProvider = 'BOLD' | 'WOMPI' | 'MERCADOPAGO';

export interface GatewayStatus {
    provider: GatewayProvider;
    active: boolean;
    publicKeyHint: string | null;
    lastUpdated: string | null;
    // Payments of the last 30 days that SuperTicket had to look up because the gateway never notified them:
    // the webhook URL is probably not registered (ms-payments-integration, payment reconciliation)
    paymentsConfirmedWithoutNotice?: number;
}

export const paymentGatewaysService = {

    // Configured gateways of the logged organizer. Secrets are never returned.
    async getStatus(): Promise<GatewayStatus[]> {
        const response = await apiClient(PAYMENT_GATEWAYS_CONFIG_URL, { method: 'GET' });

        if (!response.ok) {
            throw new Error('No fue posible consultar el estado de las pasarelas de pago');
        }

        return await response.json();
    },

    // The backend encrypts the secrets before storing them
    async saveCredentials(provider: GatewayProvider, credentials: Record<string, string>): Promise<void> {
        const response = await apiClient(PAYMENT_GATEWAYS_CONFIG_URL, {
            method: 'POST',
            body: JSON.stringify({
                provider,
                credentials: { type: provider, ...credentials }
            })
        });

        if (!response.ok) {
            const body = await response.json().catch(() => null);
            console.error('Error saving gateway credentials:', response.status, body?.message);
            throw new Error(response.status === 400
                ? 'Las credenciales no son válidas. Revisa que todos los campos estén completos.'
                : 'No fue posible guardar las credenciales. Intenta de nuevo.');
        }
    }
};
